import { useCallback } from 'react';
import { usePostHog } from 'posthog-js/react';

export const useAnalytics = () => {
  const posthog = usePostHog();

  const track = useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      posthog.capture(event, properties);
    },
    [posthog]
  );

  return { track };
};
